import BaseCustomError from './BaseCustomError';
export class CustomError extends BaseCustomError {
  constructor(message, context) {
    super(message);
    this.context = context;
    this.context = context;
  }
  getContext() {
    return this.context;
  }
}
export class OfferIdNotFoundError extends BaseCustomError {
  constructor(message, context) {
    super(message);
    this.context = context;
    this.name = 'OfferIdNotFoundError';
    this.context = context;
  }
  getContext() {
    return this.context;
  }
}